export default {
  functions: {
    functionCode: 'function Code',
    functionName: 'function Name',
    functionId: 'function Id',
    ChooseSystem: 'Choose System',
    SystemName: 'System Name',
    Prefix: 'Prefix',
    ASP: 'ASP',
    AddFunction: 'Add Function',
    EditFunction: 'Edit Function',
    RelationUrl: 'Relation Url',
    ChooseMenuUrl: 'Choose Menu Url'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/en/base/functions.js